// Package Imports


// Internal Imports


export enum AUTHORIZER_KEYS {
  AUTHORIZER_USER_POOL_DATA = "AUTHORIZER_USER_POOL_DATA"
}

export enum DEPLOY_USER_POOL_KEYS {
  POOL_ID = "DEPLOY_USER_POOL_ID",
  WEB_CLIENT_ID = "DEPLOY_USER_POOL_WEB_CLIENT_ID",
  MOBILE_CLIENT_ID = "DEPLOY_USER_POOL_MOBILE_CLIENT_ID"
}
